import { render, staticRenderFns } from "./ImageTextExplain.vue?vue&type=template&id=e5de21b4&scoped=true&lang=pug&"
import script from "./ImageTextExplain.vue?vue&type=script&lang=ts&"
export * from "./ImageTextExplain.vue?vue&type=script&lang=ts&"
import style0 from "./ImageTextExplain.vue?vue&type=style&index=0&id=e5de21b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5de21b4",
  null
  
)

export default component.exports